import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-new-version-confirmation-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './new-version-confirmation-dialog.html',
    styleUrl: './new-version-confirmation-dialog.scss'
})
export class NewVersionConfirmationDialog {
    private activeModal = inject(NgbActiveModal);

    public args!: { confirm: () => void, version: string };

    constructor() {
    }

    public onCancel(): void {
        this.activeModal.dismiss();
    }

    public confirm(): void {
        this.args.confirm();
        this.onCancel();
    }
}
